import { render, staticRenderFns } from "./WhatsAppCardPreview.vue?vue&type=template&id=6953dfd3&scoped=true&lang=pug&"
import script from "./WhatsAppCardPreview.vue?vue&type=script&lang=js&"
export * from "./WhatsAppCardPreview.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppCardPreview.vue?vue&type=style&index=0&id=6953dfd3&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6953dfd3",
  null
  
)

/* custom blocks */
import block0 from "./WhatsAppCardPreview.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports